import React from "react";
import { useTranslation } from "react-i18next";
import { getHugePlatformLogoDimensions, getPlatformLogo } from "../../../../services/helperService";
import { Platform } from "../../../../types/Platforms";

const CompatibleWithMajorSuppliers: React.FC = () => {
  const { t } = useTranslation();
  const allPlatforms = [
    Platform.SLIGRO,
    Platform.GNB,
    Platform.DUNYONG,
    Platform.VANGELDER,
    Platform.JONGVADER,
    Platform.HANOS,
    Platform.BIDFOOD,
  ];

  return (
    <div id="integrations" className="bg-accent/5 py-[30px] sm:py-20 px-5 flex flex-col items-center">
      <h3 className="text-center text-secondary text-[16px] sm:text-[18px] leading-[22px] sm:leading-[25px] font-medium font-inter">
        {t("landing.suppliers.title")}
      </h3>
      <div className="mt-4 sm:mt-[30px] overflow-x-auto w-full flex justify-center">
        <div
          className="flex justify-center items-center flex-wrap gap-4"
        >
          {allPlatforms.map((platform) => (
            <img
              key={platform}
              src={getPlatformLogo(platform)}
              alt={platform}
              className={`${getHugePlatformLogoDimensions(platform)} object-contain mr-6 ml-6`}
              draggable={false}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CompatibleWithMajorSuppliers;